// src/utils/constructionCosts.js
// ✅ Prezziario reale 2025 — Europa + Africa Occidentale
// ✅ 24 tipi struttura: Residenziale + Commerciale + Infrastrutture

// ==================== CATEGORIE ====================
export const STRUCTURE_CATEGORIES = [
    { id: 'residential', label: 'Residenziale', icon: '🏠' },
    { id: 'commercial', label: 'Commerciale', icon: '🏬' },
    { id: 'infrastructure', label: 'Infrastrutture', icon: '🛣️' },
];

// ==================== TIPI STRUTTURA ====================
export const STRUCTURE_TYPES = [
    // RESIDENZIALE
    { id: 'villa', label: 'Villa', icon: '🏡', category: 'residential', desc: 'Villa unifamiliare con giardino' },
    { id: 'duplex', label: 'Duplex', icon: '🏘️', category: 'residential', desc: 'Casa duplex su due livelli' },
    { id: 'maison', label: 'Casa Individuale', icon: '🏠', category: 'residential', desc: 'Casa unifamiliare semplice' },
    { id: 'bungalow', label: 'Bungalow', icon: '🛖', category: 'residential', desc: 'Casa a un piano, tipica Africa Occ.' },
    { id: 'appartamento', label: 'Appartamento', icon: '🏢', category: 'residential', desc: 'Unità abitativa in condominio' },
    { id: 'r1', label: 'R+1', icon: '🏠', category: 'residential', desc: 'Piano terra + 1 piano' },
    { id: 'r2', label: 'R+2', icon: '🏠', category: 'residential', desc: 'Piano terra + 2 piani' },
    { id: 'r3', label: 'R+3', icon: '🏢', category: 'residential', desc: 'Piano terra + 3 piani' },
    { id: 'immeuble', label: 'Immeuble / Palazzo', icon: '🏢', category: 'residential', desc: 'Edificio residenziale multipiano R+3+' },
    { id: 'r4plus', label: 'R+4 e oltre', icon: '🏙️', category: 'residential', desc: 'Torre residenziale / grattacielo' },

    // COMMERCIALE
    { id: 'bureau', label: 'Uffici / Bureau', icon: '🏬', category: 'commercial', desc: 'Edificio per uffici e servizi' },
    { id: 'boutique', label: 'Boutique / Negozio', icon: '🏪', category: 'commercial', desc: 'Locale commerciale al piano terra' },
    { id: 'hangar', label: 'Magazzino / Hangar', icon: '🏭', category: 'commercial', desc: 'Struttura industriale o deposito' },
    { id: 'hotel', label: 'Hotel / Auberge', icon: '🏨', category: 'commercial', desc: 'Struttura alberghiera' },
    { id: 'ecole', label: 'Scuola / École', icon: '🏫', category: 'commercial', desc: 'Edificio scolastico o formativo' },
    { id: 'clinique', label: 'Clinica / Santé', icon: '🏥', category: 'commercial', desc: 'Struttura sanitaria' },

    // INFRASTRUTTURE
    { id: 'route', label: 'Strada / Route', icon: '🛣️', category: 'infrastructure', desc: 'Strada urbana o extraurbana (km)' },
    { id: 'autoroute', label: 'Autostrada', icon: '🛤️', category: 'infrastructure', desc: 'Autostrada o voie rapide (km)' },
    { id: 'pont', label: 'Ponte', icon: '🌉', category: 'infrastructure', desc: 'Ponte o viadotto' },
    { id: 'tunnel', label: 'Tunnel', icon: '🚇', category: 'infrastructure', desc: 'Tunnel o galleria' },
    { id: 'barrage', label: 'Diga / Barrage', icon: '🏞️', category: 'infrastructure', desc: 'Diga o bacino idrico' },
    { id: 'fondations', label: 'Fondazioni', icon: '🔩', category: 'infrastructure', desc: 'Fondazioni e strutture base' },
    { id: 'reseau', label: 'Rete Idrica/Fogn.', icon: '🔧', category: 'infrastructure', desc: 'Rete idrica, fognaria, drenaggio (km)' },
    { id: 'cloture', label: 'Recinzione', icon: '🚧', category: 'infrastructure', desc: 'Recinzione perimetrale (ml)' },
];

// ==================== BUDGET BREAKDOWN PER TIPO ====================
export const BUDGET_BREAKDOWN = {
    // Residenziale
    villa: { MATERIALS: 40, LABOR: 30, EQUIPMENT: 8, SUBCONTRACT: 12, PERMITS: 5, ADMIN: 3, OTHER: 2 },
    duplex: { MATERIALS: 40, LABOR: 30, EQUIPMENT: 8, SUBCONTRACT: 12, PERMITS: 5, ADMIN: 3, OTHER: 2 },
    maison: { MATERIALS: 42, LABOR: 32, EQUIPMENT: 6, SUBCONTRACT: 10, PERMITS: 5, ADMIN: 3, OTHER: 2 },
    bungalow: { MATERIALS: 45, LABOR: 35, EQUIPMENT: 5, SUBCONTRACT: 8, PERMITS: 4, ADMIN: 2, OTHER: 1 },
    appartamento: { MATERIALS: 40, LABOR: 30, EQUIPMENT: 10, SUBCONTRACT: 10, PERMITS: 5, ADMIN: 3, OTHER: 2 },
    r1: { MATERIALS: 40, LABOR: 32, EQUIPMENT: 8, SUBCONTRACT: 10, PERMITS: 5, ADMIN: 3, OTHER: 2 },
    r2: { MATERIALS: 40, LABOR: 30, EQUIPMENT: 10, SUBCONTRACT: 10, PERMITS: 5, ADMIN: 3, OTHER: 2 },
    r3: { MATERIALS: 38, LABOR: 28, EQUIPMENT: 12, SUBCONTRACT: 12, PERMITS: 5, ADMIN: 3, OTHER: 2 },
    immeuble: { MATERIALS: 38, LABOR: 28, EQUIPMENT: 12, SUBCONTRACT: 12, PERMITS: 5, ADMIN: 3, OTHER: 2 },
    r4plus: { MATERIALS: 35, LABOR: 25, EQUIPMENT: 18, SUBCONTRACT: 12, PERMITS: 5, ADMIN: 3, OTHER: 2 },
    // Commerciale
    bureau: { MATERIALS: 35, LABOR: 25, EQUIPMENT: 12, SUBCONTRACT: 18, PERMITS: 5, ADMIN: 3, OTHER: 2 },
    boutique: { MATERIALS: 38, LABOR: 28, EQUIPMENT: 8, SUBCONTRACT: 16, PERMITS: 5, ADMIN: 3, OTHER: 2 },
    hangar: { MATERIALS: 45, LABOR: 25, EQUIPMENT: 15, SUBCONTRACT: 8, PERMITS: 4, ADMIN: 2, OTHER: 1 },
    hotel: { MATERIALS: 32, LABOR: 22, EQUIPMENT: 10, SUBCONTRACT: 25, PERMITS: 5, ADMIN: 4, OTHER: 2 },
    ecole: { MATERIALS: 38, LABOR: 28, EQUIPMENT: 10, SUBCONTRACT: 14, PERMITS: 5, ADMIN: 3, OTHER: 2 },
    clinique: { MATERIALS: 30, LABOR: 22, EQUIPMENT: 12, SUBCONTRACT: 26, PERMITS: 5, ADMIN: 3, OTHER: 2 },
    // Infrastrutture
    route: { MATERIALS: 35, LABOR: 25, EQUIPMENT: 20, SUBCONTRACT: 10, PERMITS: 5, ADMIN: 3, OTHER: 2 },
    autoroute: { MATERIALS: 32, LABOR: 22, EQUIPMENT: 25, SUBCONTRACT: 12, PERMITS: 5, ADMIN: 3, OTHER: 1 },
    pont: { MATERIALS: 38, LABOR: 22, EQUIPMENT: 25, SUBCONTRACT: 8, PERMITS: 4, ADMIN: 2, OTHER: 1 },
    tunnel: { MATERIALS: 30, LABOR: 20, EQUIPMENT: 35, SUBCONTRACT: 8, PERMITS: 4, ADMIN: 2, OTHER: 1 },
    barrage: { MATERIALS: 45, LABOR: 20, EQUIPMENT: 20, SUBCONTRACT: 8, PERMITS: 4, ADMIN: 2, OTHER: 1 },
    fondations: { MATERIALS: 42, LABOR: 28, EQUIPMENT: 18, SUBCONTRACT: 6, PERMITS: 3, ADMIN: 2, OTHER: 1 },
    reseau: { MATERIALS: 40, LABOR: 28, EQUIPMENT: 18, SUBCONTRACT: 8, PERMITS: 3, ADMIN: 2, OTHER: 1 },
    cloture: { MATERIALS: 50, LABOR: 35, EQUIPMENT: 5, SUBCONTRACT: 5, PERMITS: 2, ADMIN: 2, OTHER: 1 },
};

export const BREAKDOWN_LABELS = {
    MATERIALS: 'Materiali',
    LABOR: 'Manodopera',
    EQUIPMENT: 'Attrezzature',
    SUBCONTRACT: 'Subappalti/Impianti',
    PERMITS: 'Permessi',
    ADMIN: 'Amministrazione',
    OTHER: 'Imprevisti',
};

export const BREAKDOWN_COLORS = {
    MATERIALS: '#3b82f6', LABOR: '#10b981', EQUIPMENT: '#f59e0b',
    SUBCONTRACT: '#8b5cf6', PERMITS: '#ef4444', ADMIN: '#6b7280', OTHER: '#ec4899',
};

// ==================== PREZZI REALI 2025 ====================
export const UNIT_COSTS = {
    GNF: {
        villa: { min: 800_000_000, max: 2_500_000_000, unit: 'forfait', note: 'Villa 200-400m² clé en main' },
        duplex: { min: 400_000_000, max: 900_000_000, unit: 'forfait', note: 'Duplex 120-200m²' },
        maison: { min: 150_000_000, max: 500_000_000, unit: 'forfait', note: 'Maison individuelle 80-150m²' },
        bungalow: { min: 80_000_000, max: 200_000_000, unit: 'forfait', note: 'Bungalow simple 50-100m²' },
        appartamento: { min: 180_000_000, max: 400_000_000, unit: 'forfait', note: 'Appartement 60-120m²' },
        r1: { min: 1_000_000, max: 1_800_000, unit: 'm2', note: 'R+1 par m² construit' },
        r2: { min: 1_200_000, max: 2_200_000, unit: 'm2', note: 'R+2 par m² construit' },
        r3: { min: 1_500_000, max: 2_800_000, unit: 'm2', note: 'R+3 par m² construit' },
        immeuble: { min: 1_500_000, max: 3_500_000, unit: 'm2', note: 'Immeuble R+3+ par m²' },
        r4plus: { min: 2_000_000, max: 4_000_000, unit: 'm2', note: 'R+4+ par m²' },
        bureau: { min: 1_800_000, max: 3_500_000, unit: 'm2', note: 'Bureaux/services par m²' },
        boutique: { min: 500_000_000, max: 1_500_000_000, unit: 'forfait', note: 'Local commercial clé en main' },
        hangar: { min: 600_000, max: 1_200_000, unit: 'm2', note: 'Hangar/entrepôt par m²' },
        hotel: { min: 2_500_000, max: 6_000_000, unit: 'm2', note: 'Hôtel par m² construit' },
        ecole: { min: 800_000, max: 1_500_000, unit: 'm2', note: 'École par m²' },
        clinique: { min: 1_200_000, max: 2_500_000, unit: 'm2', note: 'Centre de santé par m²' },
        route: { min: 8_000_000_000, max: 20_000_000_000, unit: 'km', note: 'Route bitumée urbaine/km · Min. TP Guinée' },
        autoroute: { min: 15_000_000_000, max: 40_000_000_000, unit: 'km', note: 'Voie rapide/km' },
        pont: { min: 5_000_000_000, max: 30_000_000_000, unit: 'forfait', note: 'Pont moyen' },
        tunnel: { min: 20_000_000_000, max: 80_000_000_000, unit: 'forfait', note: 'Tunnel court' },
        barrage: { min: 50_000_000_000, max: 500_000_000_000, unit: 'forfait', note: 'Petit barrage' },
        fondations: { min: 200_000, max: 600_000, unit: 'm2', note: 'Fondations par m²' },
        reseau: { min: 500_000_000, max: 3_000_000_000, unit: 'km', note: 'Réseau eau/assainissement/km' },
        cloture: { min: 500_000, max: 2_000_000, unit: 'ml', note: 'Clôture par mètre linéaire' },
    },
    XOF: {
        villa: { min: 30_000_000, max: 120_000_000, unit: 'forfait', note: 'Villa 150-300m²' },
        duplex: { min: 15_000_000, max: 45_000_000, unit: 'forfait', note: 'Duplex 100-180m²' },
        maison: { min: 6_000_000, max: 25_000_000, unit: 'forfait', note: 'Maison individuelle' },
        bungalow: { min: 3_000_000, max: 10_000_000, unit: 'forfait', note: 'Bungalow simple' },
        appartamento: { min: 8_000_000, max: 20_000_000, unit: 'forfait', note: 'Appartement 50-100m²' },
        r1: { min: 100_000, max: 180_000, unit: 'm2', note: 'R+1 par m²' },
        r2: { min: 120_000, max: 220_000, unit: 'm2', note: 'R+2 par m²' },
        r3: { min: 150_000, max: 280_000, unit: 'm2', note: 'R+3 par m²' },
        immeuble: { min: 150_000, max: 300_000, unit: 'm2', note: 'Immeuble R+3+ par m²' },
        r4plus: { min: 200_000, max: 400_000, unit: 'm2', note: 'R+4+ par m²' },
        bureau: { min: 180_000, max: 350_000, unit: 'm2', note: 'Bureaux par m²' },
        boutique: { min: 5_000_000, max: 20_000_000, unit: 'forfait', note: 'Local commercial' },
        hangar: { min: 60_000, max: 120_000, unit: 'm2', note: 'Hangar par m²' },
        hotel: { min: 250_000, max: 600_000, unit: 'm2', note: 'Hôtel par m²' },
        ecole: { min: 80_000, max: 150_000, unit: 'm2', note: 'École par m²' },
        clinique: { min: 120_000, max: 250_000, unit: 'm2', note: 'Centre de santé par m²' },
        route: { min: 350_000_000, max: 750_000_000, unit: 'km', note: 'Route bitumée/km · BOAD 2024' },
        autoroute: { min: 700_000_000, max: 2_000_000_000, unit: 'km', note: 'Voie rapide/km' },
        pont: { min: 500_000_000, max: 3_000_000_000, unit: 'forfait', note: 'Pont moyen' },
        tunnel: { min: 1_000_000_000, max: 5_000_000_000, unit: 'forfait', note: 'Tunnel court' },
        barrage: { min: 2_000_000_000, max: 20_000_000_000, unit: 'forfait', note: 'Petit barrage' },
        fondations: { min: 20_000, max: 60_000, unit: 'm2', note: 'Fondations par m²' },
        reseau: { min: 50_000_000, max: 200_000_000, unit: 'km', note: 'Réseau eau/km' },
        cloture: { min: 30_000, max: 100_000, unit: 'ml', note: 'Clôture par ml' },
    },
    EUR: {
        villa: { min: 300_000, max: 1_500_000, unit: 'forfait', note: 'Villa 150-400m², chiavi in mano' },
        duplex: { min: 180_000, max: 450_000, unit: 'forfait', note: 'Duplex 100-200m²' },
        maison: { min: 100_000, max: 350_000, unit: 'forfait', note: 'Casa unifamiliare' },
        bungalow: { min: 80_000, max: 200_000, unit: 'forfait', note: 'Casa a piano terra' },
        appartamento: { min: 80_000, max: 250_000, unit: 'forfait', note: 'Appartamento 50-120m²' },
        r1: { min: 1_000, max: 1_800, unit: 'm2', note: 'R+1 per m² · ANCE 2025' },
        r2: { min: 1_200, max: 2_200, unit: 'm2', note: 'R+2 per m²' },
        r3: { min: 1_400, max: 2_500, unit: 'm2', note: 'R+3 per m²' },
        immeuble: { min: 1_200, max: 2_800, unit: 'm2', note: 'Palazzo residenziale per m²' },
        r4plus: { min: 1_600, max: 3_000, unit: 'm2', note: 'R+4+ per m²' },
        bureau: { min: 1_500, max: 3_500, unit: 'm2', note: 'Uffici per m²' },
        boutique: { min: 200_000, max: 800_000, unit: 'forfait', note: 'Locale commerciale' },
        hangar: { min: 300, max: 700, unit: 'm2', note: 'Capannone per m²' },
        hotel: { min: 2_000, max: 5_000, unit: 'm2', note: 'Hotel per m²' },
        ecole: { min: 1_500, max: 3_000, unit: 'm2', note: 'Scuola per m²' },
        clinique: { min: 2_000, max: 4_500, unit: 'm2', note: 'Clinica per m²' },
        route: { min: 800_000, max: 2_000_000, unit: 'km', note: 'Strada urbana/km · ANAS 2025' },
        autoroute: { min: 5_000_000, max: 20_000_000, unit: 'km', note: 'Autostrada/km' },
        pont: { min: 5_000_000, max: 50_000_000, unit: 'forfait', note: 'Ponte medio' },
        tunnel: { min: 20_000_000, max: 100_000_000, unit: 'forfait', note: 'Tunnel breve' },
        barrage: { min: 50_000_000, max: 500_000_000, unit: 'forfait', note: 'Piccola diga' },
        fondations: { min: 200, max: 600, unit: 'm2', note: 'Fondazioni per m²' },
        reseau: { min: 500_000, max: 2_000_000, unit: 'km', note: 'Rete idrica/fognaria per km' },
        cloture: { min: 100, max: 500, unit: 'ml', note: 'Recinzione per metro lineare' },
    },
    GBP: {
        villa: { min: 350_000, max: 2_000_000, unit: 'forfait', note: 'Detached house 150-400m²' },
        duplex: { min: 200_000, max: 500_000, unit: 'forfait', note: 'Semi-detached 100-200m²' },
        maison: { min: 150_000, max: 400_000, unit: 'forfait', note: 'Terraced house' },
        bungalow: { min: 120_000, max: 300_000, unit: 'forfait', note: 'Bungalow' },
        appartamento: { min: 100_000, max: 350_000, unit: 'forfait', note: 'Flat 50-120m²' },
        r1: { min: 1_200, max: 2_200, unit: 'm2', note: 'R+1 per m²' },
        r2: { min: 1_400, max: 2_600, unit: 'm2', note: 'R+2 per m²' },
        r3: { min: 1_600, max: 3_000, unit: 'm2', note: 'R+3 per m²' },
        immeuble: { min: 1_500, max: 3_500, unit: 'm2', note: 'Residential block per m²' },
        r4plus: { min: 2_000, max: 4_000, unit: 'm2', note: 'R+4+ per m²' },
        bureau: { min: 2_000, max: 4_500, unit: 'm2', note: 'Office per m²' },
        boutique: { min: 250_000, max: 1_000_000, unit: 'forfait', note: 'Retail unit' },
        hangar: { min: 400, max: 900, unit: 'm2', note: 'Warehouse per m²' },
        hotel: { min: 2_500, max: 6_000, unit: 'm2', note: 'Hotel per m²' },
        ecole: { min: 2_000, max: 4_000, unit: 'm2', note: 'School per m²' },
        clinique: { min: 2_500, max: 5_500, unit: 'm2', note: 'Medical centre per m²' },
        route: { min: 1_500_000, max: 4_000_000, unit: 'km', note: 'Urban road per km' },
        autoroute: { min: 8_000_000, max: 30_000_000, unit: 'km', note: 'Motorway per km' },
        pont: { min: 8_000_000, max: 60_000_000, unit: 'forfait', note: 'Medium bridge' },
        tunnel: { min: 30_000_000, max: 150_000_000, unit: 'forfait', note: 'Short tunnel' },
        barrage: { min: 60_000_000, max: 600_000_000, unit: 'forfait', note: 'Small dam' },
        fondations: { min: 300, max: 800, unit: 'm2', note: 'Foundations per m²' },
        reseau: { min: 800_000, max: 3_000_000, unit: 'km', note: 'Water/sewer network per km' },
        cloture: { min: 150, max: 600, unit: 'ml', note: 'Fencing per linear metre' },
    },
};

// ==================== STIMA BUDGET ====================
export const estimateBudget = (structureType, dimensions, currency) => {
    const costs = UNIT_COSTS[currency] || UNIT_COSTS.EUR;
    const data = costs[structureType];
    if (!data) return null;

    const mid = (data.min + data.max) / 2;
    const area = parseFloat(dimensions.area || 0);
    const length = parseFloat(dimensions.length || 0);
    const floors = parseInt(dimensions.floors || 1);
    const width = parseFloat(dimensions.width || 1);

    let estimated = mid;
    let calc = '';

    if (data.unit === 'm2') {
        const totalArea = area > 0 ? area * Math.max(1, floors) : length * width * Math.max(1, floors);
        estimated = mid * (totalArea || 1);
        calc = totalArea > 0 ? `${totalArea}m² × ${mid.toLocaleString()} ${currency}/m²` : 'Inserisci le dimensioni';
    } else if (data.unit === 'km') {
        estimated = mid * (length || 1);
        calc = `${length || 1}km × ${mid.toLocaleString()} ${currency}/km`;
    } else if (data.unit === 'ml') {
        estimated = mid * (length || 1);
        calc = `${length || 1}ml × ${mid.toLocaleString()} ${currency}/ml`;
    } else {
        // forfait — nessuna dimensione richiesta
        calc = 'Stima forfettaria per unità completa';
    }

    return {
        estimated: Math.round(estimated),
        min: Math.round(data.min * Math.max(1, area || length)),
        max: Math.round(data.max * Math.max(1, area || length)),
        unit: data.unit,
        note: data.note,
        calc,
        currency,
        isForfait: data.unit === 'forfait',
    };
};

// ==================== CONFRONTO BUDGET ====================
export const compareBudgetToMarket = (userBudget, marketEstimate, currency) => {
    if (!userBudget || !marketEstimate) return null;
    const ratio = userBudget / marketEstimate;
    if (ratio >= 1.1) return { label: '✅ Budget adeguato', color: '#10b981', msg: `+${((ratio - 1) * 100).toFixed(0)}% rispetto alla stima di mercato` };
    if (ratio >= 0.85) return { label: '⚠️ Budget al limite', color: '#f59e0b', msg: 'Vicino alla stima minima, pianifica margine' };
    return { label: '🔴 Budget insufficiente', color: '#ef4444', msg: `${((1 - ratio) * 100).toFixed(0)}% sotto la stima di mercato` };
};

// ==================== PAESI SUPPORTATI ====================
export const SUPPORTED_COUNTRIES = [
    { code: 'GN', name: 'Guinée', currency: 'GNF', region: 'WEST_AFRICA' },
    { code: 'SN', name: 'Sénégal', currency: 'XOF', region: 'WEST_AFRICA' },
    { code: 'CI', name: "Côte d'Ivoire", currency: 'XOF', region: 'WEST_AFRICA' },
    { code: 'ML', name: 'Mali', currency: 'XOF', region: 'WEST_AFRICA' },
    { code: 'BF', name: 'Burkina Faso', currency: 'XOF', region: 'WEST_AFRICA' },
    { code: 'NE', name: 'Niger', currency: 'XOF', region: 'WEST_AFRICA' },
    { code: 'BJ', name: 'Bénin', currency: 'XOF', region: 'WEST_AFRICA' },
    { code: 'TG', name: 'Togo', currency: 'XOF', region: 'WEST_AFRICA' },
    { code: 'IT', name: 'Italia', currency: 'EUR', region: 'EUROPE' },
    { code: 'FR', name: 'France', currency: 'EUR', region: 'EUROPE' },
    { code: 'DE', name: 'Deutschland', currency: 'EUR', region: 'EUROPE' },
    { code: 'ES', name: 'España', currency: 'EUR', region: 'EUROPE' },
    { code: 'GB', name: 'United Kingdom', currency: 'GBP', region: 'EUROPE' },
];